import { useRef, useEffect, useState } from 'react';

const highlights = [
  { icon: 'ri-shield-check-line', title: 'Segurança Jurídica', desc: 'Análise detalhada e precisa para proteger seus interesses em cada etapa.' },
  { icon: 'ri-user-heart-line', title: 'Atendimento Personalizado', desc: 'Cada cliente recebe atenção exclusiva, dedicada e humanizada.' },
  { icon: 'ri-bar-chart-2-line', title: 'Estratégia Eficiente', desc: 'Soluções jurídicas planejadas para alcançar os melhores resultados.' },
  { icon: 'ri-medal-line', title: 'Ética Profissional', desc: 'Atuação íntegra respeitando os princípios e diretrizes da OAB.' },
];

export default function About() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" ref={ref} className="py-24 bg-[#F4F3EF]">
      <div className="max-w-5xl mx-auto px-4 md:px-10">
        <div
          className={`transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center mb-4 justify-center md:justify-start">
            <div className="h-px w-10 bg-[#C8B07A] mr-4"></div>
            <span className="text-[#C8B07A] text-xs font-semibold tracking-[0.3em] uppercase">Sobre o Escritório</span>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-[#1F2A44] mb-6 leading-tight font-display text-center md:text-left">
            Comprometidos com sua segurança jurídica
          </h2>

          <p className="text-[#1A1A1A]/65 leading-relaxed mb-5 text-sm md:text-base">
            A <strong className="text-[#1F2A44]">Jocimar Tadioto Sociedade Individual de Advocacia</strong> é um escritório com atuação em diversas áreas do Direito, comprometido em oferecer atendimento técnico, estratégico e personalizado a cada cliente.
          </p>
          <p className="text-[#1A1A1A]/65 leading-relaxed mb-10 text-sm md:text-base">
            Com sede em Campo Grande/MS, nosso escritório presta assessoria jurídica de excelência, combinando conhecimento técnico aprofundado com uma abordagem próxima e humanizada. Cada caso é tratado com dedicação, ética e total comprometimento com os melhores resultados.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
            {highlights.map((item) => (
              <div key={item.title} className="flex gap-3 items-center group p-4 rounded-lg hover:bg-[#1F2A44]/5 transition-colors duration-300 bg-white border border-[#E5E5E5]">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1F2A44] rounded-md flex-shrink-0 group-hover:bg-[#C8B07A] transition-colors duration-300">
                  <i className={`${item.icon} text-[#C8B07A] group-hover:text-[#1F2A44] text-lg transition-colors duration-300`}></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1F2A44] text-sm mb-1">{item.title}</h4>
                  <p className="text-[#1A1A1A]/55 text-xs leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <a
            href="https://wa.me/5567999210516"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-[#1F2A44] hover:bg-[#2C3756] text-white px-6 py-3 rounded-md font-semibold text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </span>
            Entre em contato
          </a>
        </div>
      </div>
    </section>
  );
}
